import { render, staticRenderFns } from "./CurrentResourceTerm.vue?vue&type=template&id=78574479&"
import script from "./CurrentResourceTerm.vue?vue&type=script&lang=js&"
export * from "./CurrentResourceTerm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports